<div class="container-fluid ">


  <div class="row pt-4" style="    display: flex;align-items: center;">
    <div class="col-md-7 px-0 w-100">
      <!-- style="font-size: 20px; color: #237dbd;" -->
      <p class="m-0 text-uppercase"
         style="font-size: 20px;color: #262756;font-weight: bold;">Compagnies</p>
      <!-- style="font-size:15px ;display: flex;align-items: center;" -->
      <small class="text-uppercase" style="font-size:15px;color: #959090; display: flex; align-items: center;"
      > <span class="cursor-pointer" [routerLink]="['/admin/companypartner']" routerLinkActive="router-link-active">Liste des compagnies ({{linkrevendeur}}
        ) </span>
        <mat-icon>navigate_next</mat-icon>
        Utilisateurs {{linkCompany}}   </small>
    </div>
  </div>
  <div class="row   pt-2">
    <div class="col-12 col-md-12 w-100 ">
      <ngx-spinner *ngIf="usercompanyConnect ==true" bdColor="rgba(100,112,124,0.56)" size="medium" color="#233547"
                   type="ball-clip-rotate-multiple" [fullScreen]="true">
        <p style="color: white"></p>
      </ngx-spinner>

      <div class="row pl-3" style="display: none;">
        <div class="col-md-2 pl-0 pt-2">
          <div class="row pt-2 pb-2" style="background: #323d415c;  border-radius: 6px">
          </div>
        </div>

        <div class="col-3 col-md-3 w-100">
        </div>
        <div class="col-md-4 mb-3 pr-4">


          <div class="row pr-2">
            <div class="col-md-11">
              <mat-form-field class="w-100">
                <mat-label>Filtrer par utilisateur</mat-label>
                <input matInput (keyup)="applyFilter($event)" #input>

              </mat-form-field>

            </div>

            <div [matMenuTriggerFor]="menu1"
                 class="col-md-1 mat-form-field hoverButton w-100 elhoo_dashboardMenu_IconSvgStyle" style="
            height: 51px;
            display: flex;
            justify-content: space-around;
            align-items: center; cursor: pointer;" tooltipClass="my-custom-class" placement="left"
                 ngbTooltip="Exporter">


              <i style="font-size:20px" class="fas fa-download"></i>
              <mat-menu #menu1="matMenu">
                <button mat-menu-item (click)="exportDeviceTable(exportDirective, 'csv')"><img
                  src="https://img.icons8.com/color/27/000000/export-csv.png"/>
                  CSV
                </button>
                <button mat-menu-item (click)="exportDeviceTable(exportDirective, 'xlsx')">
                  <img src="https://img.icons8.com/color/27/000000/export-excel.png"/> xlsx
                </button>


                <button mat-menu-item (click)="exportDeviceTable(exportDirective, 'json')"><img
                  src="https://img.icons8.com/color/27/000000/json-download.png"/>
                  JSON
                </button>


                <button mat-menu-item (click)="exportDeviceTable(exportDirective, 'txt')">
                  <img src="https://img.icons8.com/color/27/000000/rich-text-converter.png"/>
                  TXT
                </button>

                <button mat-menu-item (click)="exportDeviceTablePDF()">
                  <img src="https://img.icons8.com/color/27/000000/export-pdf.png"/>
                  PDF
                </button>

              </mat-menu>

            </div>


          </div>


        </div>


      </div>

      <div class="row w-100 m-0 mb-2">
        <div class="col-2">
          <div class="export-icons d-flex mb-2">
            <div class="icn-sec">
              <!-- (click)="exportExcel(exportDirective, 'xlsx')" -->
              <img
                (click)="exportDeviceTable(exportDirective, 'csv')"
                src="assets/newImages/excel-svg.svg" ngbTooltip="Expoter EXCEL"/>
            </div>
            <div class="icn-sec">
              <!-- (click)="exportTable()" -->
              <img (click)="exportDeviceTablePDF()"
                   src="assets/newImages/pdf-svg.svg"
                   ngbTooltip="Expoter PDF"/>
            </div>
          </div>
        </div>
        <div class="col-2">

        </div>
        <div class="col-2">

        </div>
        <div class="col-2 w-100">
          <div
            *ngIf="listItems.length >1"
            (click)="deleteUser('moreThanOne',null)"
            class="mat-form-field"
            placement="left"
            ngbTooltip="Supprimer utilisateurs"
            style="
                  height: 55px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 63px;
                  float: right;
                "
          >
            <mat-icon style="font-size: 25px; padding: 0 !important"
            >delete_forever</mat-icon
            >
          </div>
        </div>

        <div class="col-1 w-100" style="text-align: right;margin-top: -20px;">

          <img placement="left"
               ngbTooltip="Ajouter Utilisateur"
               style="width: 100px;"
               src="assets/icons/add-user.svg"
               (click)="addCompanyUser()"/>

        </div>

        <div class="col-3">
          <div class="col-md-11">
            <mat-form-field class="w-100">
              <mat-label>Chercher par nom utilisateur</mat-label>
              <input matInput (keyup)="applyFilter($event)" #input>

            </mat-form-field>

          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 px-2  ">
          <div class="row mr-0">

            <div style="    max-width: 98%;    overflow: auto;"
                 class="col-md-12  px-0 mx-4 example-container  custmStyleheaderTable">
              <ngx-spinner *ngIf="usercompany ==true" bdColor="rgba(100,112,124,0.56)" size="medium" color="#233547"
                           type="ball-clip-rotate-multiple" [fullScreen]="false">
                <p style="color: white"></p>
              </ngx-spinner>
              <table #exportDirective="matTableExporter"
                     matTableExporter mat-table [dataSource]="dataSource"
                     class="   mat-elevation-z8 w-100">

                <!-- Checkbox Column -->
                <ng-container matColumnDef="select">
                  <th mat-header-cell *matHeaderCellDef>

                  </th>
                  <td (click)="selection.toggle(element)" mat-cell *matCellDef="let element">
                    <mat-checkbox disabled (click)="$event.stopPropagation()"
                                  (change)="$event ? selection.toggle(element) : null"
                                  [checked]="selection.isSelected(element)"
                                  [aria-label]="checkboxLabel(element)">
                    </mat-checkbox>
                  </td>
                </ng-container>

                <!-- Position Column -->
                <ng-container matColumnDef="ID">
                  <th mat-header-cell *matHeaderCellDef> ID.</th>
                  <td (click)="selection.toggle(element)"
                       mat-cell *matCellDef="let element"> {{element?.id}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="statut">
                  <th mat-header-cell *matHeaderCellDef> Statut</th>
                  <td (click)="selection.toggle(element)"
                       mat-cell *matCellDef="let element"></td>
                </ng-container>

                <!-- Weight Column -->
                <ng-container matColumnDef="Nom">
                  <th mat-header-cell *matHeaderCellDef> Nom</th>
                  <td (click)="selection.toggle(element)"
                       mat-cell *matCellDef="let element"> {{element?.last_name}}
                  </td>
                </ng-container>


                <!-- Weight Column -->
                <ng-container matColumnDef="Prenom">
                  <th mat-header-cell *matHeaderCellDef> Prénom</th>
                  <td (click)="selection.toggle(element)"
                       mat-cell *matCellDef="let element"> {{element?.first_name}}
                  </td>
                </ng-container>

                <!-- Symbol Column -->
                <ng-container matColumnDef="Utilisateur">
                  <th mat-header-cell *matHeaderCellDef> Utilisateur</th>
                  <td (click)="selection.toggle(element)"
                       mat-cell *matCellDef="let element">
                    <!-- class="colorTable" -->
                    <b style="color: #262756;"
                    >  {{element?.username}} </b></td>
                </ng-container>

                <!-- Symbol Column -->
                <ng-container matColumnDef="Date_de_creation">
                  <th mat-header-cell *matHeaderCellDef> Date de création</th>
                  <td (click)="selection.toggle(element)"
                       mat-cell *matCellDef="let element">
                    {{element?.created_at | date:'medium' }} </td>
                </ng-container>

                <!-- Symbol Column -->
                <ng-container matColumnDef="Derniere_connexion">
                  <th mat-header-cell *matHeaderCellDef> Dernière connexion</th>
                  <td (click)="selection.toggle(element)"
                       mat-cell *matCellDef="let element"> {{element?.last_login }}
                  </td>
                </ng-container>


                <!-- Symbol Column -->
                <ng-container matColumnDef="Date_expiration">
                  <th mat-header-cell *matHeaderCellDef> Date expiration</th>
                  <td (click)="selection.toggle(element)"
                       mat-cell
                      *matCellDef="let element"> {{element?.expiration_date
                    }}
                  </td>
                </ng-container>

                <!-- Symbol Column -->

                <ng-container matColumnDef="Active">
                  <th mat-header-cell *matHeaderCellDef> Active</th>
                  <td mat-cell *matCellDef="let element"
                      >
                    <!-- src="https://img.icons8.com/fluent/32/000000/checked-user-male.png"  -->
                    <img placement="left" ngbTooltip="Utilisateur non bloqué" class="pr-2"
                         *ngIf="element?.is_active ==1"
                         src="assets/icons/UtilisateurNonbloque.svg"
                    />
                    <!-- src="https://img.icons8.com/color/32/000000/remove-user-male--v1.png"  -->
                    <img placement="left" ngbTooltip="Utilisateur bloqué" class="pr-2" *ngIf="element?.is_active != 1"
                         src="assets/icons/Utilisateurbloque.svg"
                    />

                  </td>

                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="Action">
                  <th mat-header-cell *matHeaderCellDef> Actions</th>
                  <td (click)="selection.toggle(element)" mat-cell *matCellDef="let element">

                    <!-- src="https://img.icons8.com/color/34/000000/enter-2.png" -->
                    <a (click)="connectUser(element?.id ,element?.last_name ,element?.first_name)"> <img
                      [ngClass]="{disable:listItems.length>1}"
                      placement="left"
                      ngbTooltip="Se connecter en tant que {{element?.last_name}} {{element?.first_name}} "
                      src="assets/icons/Utilisateurscompagnie.svg"
                    /></a>

                    <img [ngClass]="{disable:listItems.length>1}"
                    placement="left"
                         ngbTooltip="Modifier utilisateur"
                         (click)="updateCompanyUser('oneItem',element)"

                         src="assets/icons/icon-modifier.svg"
                    />
                    <a [ngClass]="{disable:listItems.length>1}">
                      <img placement="left" ngbTooltip="Supprimer utilisateur"
                           src="assets/icons/icon-delete.svg"
                           (click)="deleteUser('oneItem',element?.id)"
                      />
                    </a>

                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="getgogo()">
                </tr>
                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="12">
                    Aucune donnée correspondante à votre recherche
                  </td>
                </tr>
              </table>
              <mat-paginator #paginator [pageSize]="15" [pageSizeOptions]="[15, 30, 100]" (page)="pageChanged($event)"
                             showFirstLastButtons></mat-paginator>


            </div>


          </div>


        </div>


      </div>


      <table style="display: none;" #exportDirective="matTableExporter" id="ExampleTableusercompany" matTableExporter
             mat-table [dataSource]="dataSource" class="mat-elevation-z8 w-100">

        <!-- Checkbox Column -->
        <ng-container matColumnDef="select" style="display: none;visibility: hidden;">
          <th mat-header-cell *matHeaderCellDef>

          </th>
          <td mat-cell *matCellDef="let row">

          </td>
        </ng-container>

        <!-- Position Column -->
        <ng-container matColumnDef="ID">
          <th mat-header-cell *matHeaderCellDef> ID</th>
          <td mat-cell *matCellDef="let element"> {{element?.id}} </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="statut">
          <th mat-header-cell *matHeaderCellDef> Statut</th>
          <td mat-cell *matCellDef="let element"></td>
        </ng-container>

        <!-- Weight Column -->
        <ng-container matColumnDef="Nom">
          <th mat-header-cell *matHeaderCellDef> Nom</th>
          <td mat-cell *matCellDef="let element"> {{element?.last_name}} </td>
        </ng-container>


        <!-- Weight Column -->
        <ng-container matColumnDef="Prenom">
          <th mat-header-cell *matHeaderCellDef> Prénom</th>
          <td mat-cell *matCellDef="let element"> {{element?.first_name}} </td>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="Utilisateur">
          <th mat-header-cell *matHeaderCellDef> Utilisateur</th>
          <td mat-cell *matCellDef="let element"> {{element?.username}} </td>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="Date_de_creation">
          <th mat-header-cell *matHeaderCellDef> Date_de_creation</th>
          <td mat-cell *matCellDef="let element"> {{element?.created_at  }} </td>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="Derniere_connexion">
          <th mat-header-cell *matHeaderCellDef> Dernière_connexion</th>
          <td mat-cell *matCellDef="let element"></td>
        </ng-container>


        <!-- Symbol Column -->
        <ng-container matColumnDef="Date_expiration">
          <th mat-header-cell *matHeaderCellDef> Date_expiration</th>
          <td mat-cell *matCellDef="let element"> {{element?.expiration_date}} </td>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="Active">
          <th mat-header-cell *matHeaderCellDef> Active</th>
          <td mat-cell *matCellDef="let element"> {{element?.is_active}} </td>
        </ng-container>


        <tr mat-header-row *matHeaderRowDef="displayedColumns1"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns1;" (click)="selection.toggle(row)">
        </tr>
      </table>


    </div>
  </div>
</div>
